var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdobeFonts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "st_x5F_cc_x5F_app_x5F_RGB.svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240.0004 234.0004",
    style: {
      enableBackground: "new 0 0 240.0004 234.0004"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.9997,
    y1: 234.0002,
    x2: 119.9997,
    y2: 0.0002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#201F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#313131"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0003,
    y: 0.0002,
    className: "st0",
    width: 240,
    height: 234
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.24969,97.95853c-5.60328,18.77988-10.28088,36.91208-15.88416,54.63138 c-3.18081,9.99579-6.66385,19.53729-11.05544,25.59485c-4.84678,6.81497-13.93402,13.32771-24.83743,13.32771 c-7.72443,0-15.29683-3.63509-15.29683-11.66174c0-4.99789,5.14901-9.69264,9.23837-9.69264 c2.42339,0,3.63508,1.36282,4.24046,2.42339c3.7862,6.81497,7.42128,10.75229,9.08724,10.75229s3.02878-2.27135,5.7544-12.1151 l19.82331-73.26013H99.08337c-1.06058-3.18081,0.45427-7.11812,2.27135-7.87554h14.23625 c2.72562-8.7841,5.92356-17.60862,10.46719-25.63529c6.81497-12.26713,17.7193-21.95976,32.71205-21.95976 c11.3586,0,16.05333,5.45216,16.05333,12.41917c-0.15111,7.42036-6.66293,11.20656-9.69263,11.20656 c-2.42247,0-3.63416-1.81709-4.39159-4.39159c-2.57451-9.69263-5.90643-12.57029-7.87555-12.57029 c-1.9682,0-4.99789,3.63416-8.3289,11.20656c-4.3925,9.54151-7.28729,19.72977-10.01291,29.72464h17.26501 c1.05966,2.12023,0.15112,6.66385-2.42339,7.87554H132.24969z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeFonts);
export default __webpack_public_path__ + "static/media/Adobe_Fonts.bf94f46a4ce1fd0b838d33545f0f160e.svg";
export { ForwardRef as ReactComponent };